export const API_SEARCH_DOCTOR = 'API_SEARCH_DOCTOR'
export const API_SEARCH_DOCTOR_SUCCESS = 'API_SEARCH_DOCTOR_SUCCESS'
export const API_SEARCH_DOCTOR_FAIL = 'API_SEARCH_DOCTOR_FAIL'

export const API_GET_DOCTOR_EXISTS = 'API_GET_DOCTOR_EXISTS'
export const API_GET_DOCTOR_EXISTS_SUCCESS = 'API_GET_DOCTOR_EXISTS_SUCCESS'
export const API_GET_DOCTOR_EXISTS_FAIL = 'API_GET_DOCTOR_EXISTS_FAIL'

export const API_PATCH_DOCTOR = 'API_PATCH_DOCTOR'
export const API_PATCH_DOCTOR_SUCCESS = 'API_PATCH_DOCTOR_SUCCESS'
export const API_PATCH_DOCTOR_FAIL = 'API_PATCH_DOCTOR_FAIL'

export const API_POST_DOCTOR = 'API_POST_DOCTOR'
export const API_POST_DOCTOR_SUCCESS = 'API_POST_DOCTOR_SUCCESS'
export const API_POST_DOCTOR_FAIL = 'API_POST_DOCTOR_FAIL'

export const API_GET_DOCTOR_ANALYSES = 'API_GET_DOCTOR_ANALYSES'

export const API_GET_DOCTOR_PACKS = 'API_GET_DOCTOR_PACKS'

export const API_POST_COPY_PACK_TO_DOCTOR = 'API_POST_COPY_PACK_TO_DOCTOR'
export const API_POST_COPY_PACK_TO_DOCTOR_SUCCESS = 'API_POST_COPY_PACK_TO_DOCTOR_SUCCESS'
export const API_POST_COPY_PACK_TO_DOCTOR_FAIL = 'API_POST_COPY_PACK_TO_DOCTOR_FAIL'